module.exports = __webpack_public_path__ + "img/fire-tv.02664e04.svg";